import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import Button from 'shared/modules/common/components/atoms/Button';
type Props = {
  onReturnButtonPress: () => void;
};

const PEPInfo = (props: Props) => {
  const { onReturnButtonPress } = props;
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  return (
    <View style={styles.root}>
      <Text style={styles.mainTitle}>{`外国PEPsとは`} </Text>
      <View style={styles.panel}>
        <Text style={styles.panelText}>
          {`外国PEPs：Politically Exposed Persons（重要な公的地位にある者）には下記の方々が該当します。\n\n`}
        </Text>
        <Text style={styles.panelText}>{`① 外国の元首\n\n`}</Text>
        <Text
          style={styles.panelText}
        >{`② 外国において下記の職にある者 ・我が国における内閣総理大臣その他の国務大臣及び副大臣に相当する職 ・我が国における衆議院議長、衆議院副議長、参議院議長又は参議院副議長に相当する職 ・我が国における最高裁判所の裁判官に相当する職 ・我が国における特命全権大使、特命全権公使、特派大使、政府代表又は全権委員に相当する 職 ・我が国における統合幕僚長、統合幕僚副長、陸上幕僚長、陸上幕僚副長、海上幕僚長、海上 幕僚副長、航空幕僚長又は航空幕僚副長に相当する職 ・中央銀行の役員 ・予算について国会の議決を経、又は承認を受けなければならない法人の役員\n\n`}</Text>
        <Text style={styles.panelText}>{`③ 過去に①又は②であった者 \n\n`}</Text>
        <Text style={styles.panelText}>{`④ ①～③の家族\n\n`}</Text>
        <Text
          style={styles.panelText}
        >{`⑤ ①～④が実質的支配者である法人\n`}</Text>
      </View>
      <View style={[styles.buttonContainer, isBigScreen && { paddingTop: 44 }]}>
        <Button
          onPress={onReturnButtonPress}
          title="戻る"
          variant="outlined"
          style={styles.returnButton}
          id="ekyc-pep-info-return-button"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  mainTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#000',
  },
  panel: {
    padding: 16,
    borderRadius: 16,
    backgroundColor: '#fff',
    marginVertical: 16,
  },
  panelText: {
    fontSize: 16,
    color: '#1C1C1C',
    fontWeight: '300',
  },
  buttonContainer: {
    flexDirection: 'column',
    flex: 1,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  returnButton: {
    marginTop: 18,
    paddingVertical: 8,
    paddingHorizontal: 8,
  },
});

export default PEPInfo;
